import { SHAPE_STROKE_PROPS } from './stroke-props';

interface HexagonProps {
  strokeDasharray: string | undefined;
}

export default function Hexagon({ strokeDasharray }: HexagonProps) {
  return (
    <polygon
      points="25,0 75,0 100,50 75,100 25,100 0,50"
      strokeDasharray={strokeDasharray}
      {...SHAPE_STROKE_PROPS}
    />
  );
}
